
    import {Component, Prop, Vue} from 'vue-property-decorator'
    import {ServiceLineListDto} from "@/api/commonConfig";

    @Component({
        name: 'ShareServiceLine',
    })
    export default class ShareServiceLine extends Vue {
        @Prop({ default: () => {return []} }) list!: ServiceLineListDto[];
        showTemp = false

        show () {
            this.showTemp = true
        }
    }
